<div class="dc-empty-state__wrapper" *ngIf="type">
  <div class="dc-empty-state__content {{type}}"></div>
  <div class="dc-empty-state__message">
    <ng-content></ng-content>
  </div>
</div>
